import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { TextPlugin } from 'gsap/TextPlugin'

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, CSSRulePlugin, ScrollToPlugin, TextPlugin)

export default defineNuxtPlugin(() => {
  return {
    provide: {
      gsap,
      scrollTrigger: ScrollTrigger,
    },
  }
})
